import { gatewayPhone } from "src/gateways/gatewayPhone";

import {
  TransferAvailableResponse,
  WorkforcePresenceResponse,
} from "../_types/workforcePresence.types";

export const fetchWorkforcePresence = async (
  companyId: number,
): Promise<WorkforcePresenceResponse> => {
  const { data } = await gatewayPhone.get<WorkforcePresenceResponse>(
    `/company/workforce-presence/${companyId}`,
  );

  return data;
};

export const fetchAgentPresenceAvailable = async (
  companyId: number,
): Promise<TransferAvailableResponse> => {
  const { data } = await gatewayPhone.get<TransferAvailableResponse>(
    `/company/agent-status/${companyId}`,
  );

  return data;
};
